"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _AuthActions = require("../../../modules/auth/AuthActions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var AppTopBar = /*#__PURE__*/function (_React$Component) {
  _inherits(AppTopBar, _React$Component);

  function AppTopBar(props) {
    var _this;

    _classCallCheck(this, AppTopBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppTopBar).call(this, props));
    _this.state = {
      menuOpened: false,
      notificatonsOpened: false
    };
    return _this;
  }

  _createClass(AppTopBar, [{
    key: "showMenu",
    value: function showMenu() {
      this.setState({
        menuOpened: true
      });
    }
  }, {
    key: "hideMenu",
    value: function hideMenu() {
      this.setState({
        menuOpened: false
      });
    }
  }, {
    key: "showNotifications",
    value: function showNotifications() {
      this.setState({
        notificatonsOpened: true
      });
    }
  }, {
    key: "hideNotifications",
    value: function hideNotifications() {
      this.setState({
        notificatonsOpened: false
      });
    }
  }, {
    key: "getElementStyle",
    value: function getElementStyle() {
      var style = {
        opacity: '0',
        top: '54px'
      };

      if (this.state.menuOpened) {
        style.opacity = '1';
        style.top = '38px';
      }

      return style;
    }
  }, {
    key: "getLinkStyle",
    value: function getLinkStyle() {
      var linkStyle = {
        display: 'none'
      };

      if (this.state.menuOpened) {
        linkStyle.display = 'block';
      }

      return linkStyle;
    }
  }, {
    key: "getNotifications",
    value: function getNotifications() {
      var notificatonStyle = {
        opacity: '1',
        display: 'none'
      };

      if (this.state.notificatonsOpened) {
        notificatonStyle.opacity = '1';
        notificatonStyle.display = 'block';
      }

      return notificatonStyle;
    }
  }, {
    key: "notifications",
    value: function notifications() {
      var x = document.getElementById("notif");

      if (x.style.display === "none") {
        x.style.display = "block";
      } else {
        x.style.display = "none";
      }
    }
  }, {
    key: "logoutUser",
    value: function logoutUser(token) {
      this.props.userLoggedOut(token);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var style = this.getElementStyle();
      var linkStyle = this.getLinkStyle();
      var notificatonStyle = this.getNotifications();
      return _react["default"].createElement("div", {
        className: "dashboard-menu-top",
        onMouseLeave: this.hideMenu.bind(this)
      }, _react["default"].createElement("div", {
        className: "dark-blur",
        onMouseLeave: this.hideNotifications.bind(this)
      }), _react["default"].createElement("p", {
        className: "left"
      }, "BANKVAULT"), _react["default"].createElement("a", {
        className: "right",
        onMouseEnter: this.showMenu.bind(this)
      }, _react["default"].createElement("i", {
        className: "fa fa-cogs",
        "aria-hidden": "true"
      }), " Superadmin"), _react["default"].createElement("div", {
        className: "superadmin-dropdown",
        style: style
      }, _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", null, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        onClick: function onClick(token) {
          return _this2.logoutUser(token);
        },
        style: linkStyle
      }, _react["default"].createElement("i", {
        className: "fa fa-eject",
        "aria-hidden": "true"
      }), " Log out"))));
    }
  }]);

  return AppTopBar;
}(_react["default"].Component); // const mapStateToProps = (state: { auth: { token: any; profile: any; }; }) => {
//     return {
//         token: state.auth.token,
//         profile: state.auth.profile,
//     }
// }


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    userLoggedOut: function userLoggedOut() {
      return dispatch((0, _AuthActions.logoutTriggerAction)());
    },
    userLoggedIn: function userLoggedIn(token, account) {
      return dispatch((0, _AuthActions.loginTriggerAction)(token, account));
    }
  };
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(AppTopBar);

exports["default"] = _default;